import React from "react";
import { Message } from "src/modules/communication-protobuf";
import { pairingResults, pairingSources } from "src/modules/pairing/constants";
import { withPurchase } from "src/modules/purchase/PurchaseContext";
import Presence from "src/constants/presence";

import * as actions from "../duck/actions";
import ConfirmationDialog from "../components/ConfirmationDialog";
import FailureDialog from "../components/FailureDialog";
import ResponderContext from "./Context";

class PairingResponder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      providing: {
        sendResponseMessage: this.sendResponseMessage
      }
    };
  }

  componentDidMount = () => {
    this.initiate();
  };

  initiate() {
    const { messenger } = this.props;

    messenger.on("requestPairingMessage", (message, from) => {
      const { dispatch, isResponding, isRequesting, securityCode, presence } =
        this.props;
      const request = { ...message, from };

      if (
        request.securityCode !== securityCode &&
        request.pairingSource === pairingSources.AUTO_PAIRING
      ) {
        this.sendResponseMessage({
          to: from,
          pairingType: request.pairingType,
          requestId: request.requestId,
          result: pairingResults.FAILED
        });
        return;
      }
      if (isResponding || isRequesting) {
        this.sendResponseMessage({
          to: from,
          pairingType: request.pairingType,
          requestId: request.requestId,
          result: pairingResults.PAIRING_IN_PROGRESS
        });
        return;
      }
      if (
        presence === Presence.RECEIVER_CONNECTED ||
        presence === Presence.SENDER_CONNECTED
      ) {
        this.sendResponseMessage({
          to: from,
          pairingType: request.pairingType,
          requestId: request.requestId,
          result: pairingResults.REJECTED
        });
        return;
      }

      dispatch(actions.receivedRequest(request));
    });
  }

  sendResponseMessage = (params = {}) => {
    const { messenger, request, familyName, deviceName } = this.props;

    const message = Message.RequestPairingResponseMessage.create({
      familyName,
      deviceName,
      result: params.result,
      pairingType: params.pairingType || request.pairingType,
      requestId: params.requestId || request.requestId,
      otp: params.otpData ? params.otpData.otp : undefined,
      authId: params.otpData ? params.otpData.authId : undefined
    });

    return messenger.sendAsEnvelope({
      to: params.to || request.from,
      payload: { message }
    });
  };

  render() {
    const { isResponding, error, pairedDevices, isFreeVersion, purchase } =
      this.props;

    const failureDialog = error ? <FailureDialog /> : null;
    const confirmationDialog = isResponding ? (
      <ConfirmationDialog
        togglePurchaseFlow={() => purchase.open({ content: "unlimited" })}
        shouldOpenPurchaseFlow={
          isFreeVersion && Object.keys(pairedDevices).length >= 1
        }
        pairingResponder={this.state.providing}
      />
    ) : null;
    return (
      <ResponderContext.Provider value={this.state.providing}>
        {failureDialog || confirmationDialog}
        {this.props.children}
      </ResponderContext.Provider>
    );
  }
}

export default withPurchase(PairingResponder);
